import { render, staticRenderFns } from "./reprintDialog1.vue?vue&type=template&id=12378c99&scoped=true&"
import script from "./reprintDialog1.vue?vue&type=script&lang=js&"
export * from "./reprintDialog1.vue?vue&type=script&lang=js&"
import style0 from "./reprintDialog1.vue?vue&type=style&index=0&id=12378c99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12378c99",
  null
  
)

export default component.exports